import A11ydialog from 'a11y-dialog';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const $ = window.jQuery;

const videomodal = {
	init() {
		const $modules = $('[data-video-modal]');
		if (!$modules.length) {
			return;
		}

		// Initialize regular video modal buttons
		this.initRegularVideoButtons();

		// Initialize tombstone video buttons
		this.initTombstoneVideoButtons();
	},

	initRegularVideoButtons() {
		const triggerBtn = $('[data-modal-open]');

		// Add ARIA attributes to trigger buttons
		triggerBtn.each(function () {
			const $btn = $(this);
			const modalId = $btn.data('modal-open');
			const modalSelector = modalId.replace(/\[|\]/g, '');
			const $modal = $(`[${modalSelector}]`);

			if ($modal.length) {
				const modalDomId = $modal.attr('id');
				$btn.attr({
					role: 'button',
					'aria-haspopup': 'dialog',
					'aria-controls': modalDomId,
				});
			}
		});

		triggerBtn.on('click', (event) => {
			event.preventDefault();
			const $trigger = $(event.currentTarget);
			const modalId = $trigger.data('modal-open');

			this.openVideoModal(modalId, $trigger);
		});
	},

	initTombstoneVideoButtons() {
		const tombstoneBtns = $('[data-toggle-gdr-video]');

		if (!tombstoneBtns.length) {
			return;
		}

		// Add ARIA attributes to tombstone video buttons
		tombstoneBtns.attr({
			role: 'button',
			'aria-haspopup': 'dialog',
			'aria-label': 'Visa video',
		});

		tombstoneBtns.on('click', (event) => {
			event.preventDefault();
			const $trigger = $(event.currentTarget);

			// Get the post ID directly from the button
			const postId = $trigger.data('post-id');

			if (!postId) {
				// Fallback to parent element if button doesn't have the ID
				const $tombstone = $trigger.closest('[data-id]');
				const parentPostId = $tombstone.data('id');

				if (!parentPostId) {
					console.error('Could not find post ID for tombstone video');
					return;
				}

				this.loadTombstoneVideo(parentPostId, $trigger);
			} else {
				this.loadTombstoneVideo(postId, $trigger);
			}
		});
	},

	loadTombstoneVideo(postId, $trigger) {
		// Show loading indicator
		$('body').addClass('loading');

		// Load the video modal via AJAX
		$.ajax({
			url: window.edu.ajaxUrl || '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'get_tombstone_video',
				post_id: postId,
				nonce: window.edurusAjax?.nonce,
			},
			success: (response) => {
				if (response.success && response.data.html) {
					// Append the modal HTML to the body if it doesn't exist
					const $existingModal = $(`[data-video-modal="${response.data.video_id}"]`);

					if (!$existingModal.length) {
						$('body').append(response.data.html);
					}

					// Open the modal
					const modalSelector = `[data-video-modal="${response.data.video_id}"]`;
					this.openVideoModal(modalSelector, $trigger);
				} else {
					console.error('Failed to load video:', response.data?.message || 'Unknown error');
				}
			},
			error: (xhr, status, error) => {
				console.error('AJAX error:', error);
			},
			complete: () => {
				// Hide loading indicator
				$('body').removeClass('loading');
			},
		});
	},

	openVideoModal(modalId, $trigger) {
		// Store the element that had focus before opening the modal
		const $prevFocusedEl = $(document.activeElement);

		// Check if the modal element exists
		const $modalEl = $(modalId);
		if (!$modalEl.length) {
			console.error(`Modal element not found with selector: ${modalId}`);
			return;
		}

		const modalel = $modalEl[0];
		const modal = new A11ydialog(modalel);

		// Find the video element inside the modal
		const $video = $modalEl.find('video');
		const video = $video.length ? $video[0] : null;

		// Add proper ARIA labels if they don't exist
		if (!$modalEl.attr('aria-labelledby')) {
			$modalEl.attr('aria-labelledby', `dialog-title-${modalel.id}`);
		}

		// Add captions button if video exists and doesn't have one
		if (video && video.textTracks && video.textTracks.length === 0) {
			// Check if the video has a source with captions
			const $source = $video.find('source[src$=".vtt"]');
			if ($source.length) {
				const track = document.createElement('track');
				track.kind = 'captions';
				track.label = 'Svenska';
				track.srclang = 'sv';
				track.src = $source.attr('src').replace('.mp4', '.vtt');
				video.appendChild(track);
			}
		}

		// Handle ESC key manually in case A11yDialog doesn't handle it properly
		const handleEscKey = (keyEvent) => {
			if (keyEvent.key === 'Escape') {
				modal.hide();
			}
		};

		document.addEventListener('keydown', handleEscKey);

		// eslint-disable-next-line prefer-arrow-callback
		modal.on('hide', function () {
			enableBodyScroll(modalel);
			$('body').removeClass('has-modal-open');
			// Explicitly set aria-hidden
			$modalEl.attr('aria-hidden', 'true');

			// Clean up event listeners
			document.removeEventListener('keydown', handleEscKey);

			// Pause video when modal is closed
			if (video) {
				video.pause();
			}

			// Return focus to the element that had focus before the modal was opened
			setTimeout(() => {
				$prevFocusedEl.focus();
			}, 100);

			modal.destroy();
		});

		// eslint-disable-next-line prefer-arrow-callback
		modal.on('show', function (dialogel) {
			disableBodyScroll(modalel);
			$('body').addClass('has-modal-open');
			// Explicitly set aria-hidden
			$modalEl.attr('aria-hidden', 'false');

			// Focus on the first focusable element in the modal (usually the close button)
			setTimeout(() => {
				const $closeBtn = $(dialogel).find('[data-a11y-dialog-hide]').first();
				$closeBtn.focus();
			}, 100);

			if (video) {
				// Ensure video controls are enabled for keyboard navigation
				video.controls = true;

				// Convert to lowercase and ensure correct property name
				video.currentTime = 0;

				// Always play the video automatically when modal opens
				video.play().catch((err) => {
					console.warn('Autoplay failed:', err);
					// If autoplay fails, show a play button or message
				});
			}
		});

		modal.show();
		disableBodyScroll(modalel);
	}
};

export default videomodal;
